module.exports = __webpack_public_path__ + "img/find_search_result.2731ab17.png";